import React from 'react';

const ImagePlaceHolderSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="66" height="54" viewBox="0 0 66 54" fill="none">
            <path
                d="M60 0H6C3 0 0 3 0 6V48C0 51.3 2.7 54 6 54H60C63 54 66 51 66 48V6C66 3 63 0 60 0ZM60 47.76C59.94 47.85 59.82 47.94 59.76 48H6V6.24L6.24 6H59.73C59.82 6.06 59.91 6.18 59.97 6.24V47.76H60ZM30 37.53L22.5 28.5L12 42H54L40.5 24L30 37.53Z"
                fill="#B9C1C7"/>
        </svg>
    );
};

export default ImagePlaceHolderSvg;